import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

type ToastPosition = 'top' | 'top-start' | 'top-end' | 'center' | 'center-start' | 'center-end' | 'bottom' | 'bottom-start' | 'bottom-end'

export function showMessage(
  msg = 'Example notification text.',
  position: ToastPosition = 'bottom-end',
  showCloseButton = true,
  duration = 3000,
): void {
  Swal.mixin({
    toast: true,
    position,
    icon: 'success',
    showConfirmButton: false,
    timer: duration,
    showCloseButton,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.style.zIndex = '99999'
      const container = toast.parentElement
      if (container) container.style.zIndex = '99999'
    },
  }).fire({ title: msg })
}
